export const CURRENCIES = [
  { name: 'Euro', code: 'EUR' },
  { name: 'Afghan Afghani', code: 'AFN' },
  { name: 'Albanian Lek', code: 'ALL' },
  { name: 'Algerian Dinar', code: 'DZD' },
  { name: 'Argentine Peso', code: 'ARS' },
  { name: 'Australian Dollar', code: 'AUD' },
  { name: 'Bahamian Dollar', code: 'BSD' },
  { name: 'Bahraini Dinar', code: 'BHD' },
  { name: 'Bangladesh Taka', code: 'BDT' },
  { name: 'Barbados Dollar', code: 'BBD' },
  { name: 'Belize Dollar', code: 'BZD' },
  { name: 'Bermuda Dollar', code: 'BMD' },
  { name: 'Bolivian Boliviano', code: 'BOB' },
  { name: 'Bosnia Convertible Marks', code: 'BAM' },
  { name: 'Brazilian Real', code: 'BRL' },
  { name: 'Brunei Dollar', code: 'BND' },
  { name: 'Bulgarian Lev', code: 'BGN' },
  { name: 'Burundi Franc', code: 'BIF' },
  { name: 'Cambodian Riel', code: 'KHR' },
  { name: 'Canadian Dollar', code: 'CAD' },
  { name: 'Cape Verde Escudo', code: 'CVE' },
  { name: 'Cayman Islands Dollar', code: 'KYD' },
  { name: 'CFA Franc', code: 'XOF' },
  { name: 'CFA Franc', code: 'XAF' },
  { name: 'CFP Franc', code: 'XPF' },
  { name: 'Chilean Peso', code: 'CLP' },
  { name: 'Chinese Yuan Renminbi', code: 'CNY' },
  { name: 'Colombian Peso', code: 'COP' },
  { name: 'Comoro Franc', code: 'KMF' },
  { name: 'Costa Rican Colon', code: 'CRC' },
  { name: 'Croatian Kuna', code: 'HRK' },
  { name: 'Cuban Peso', code: 'CUP' },
  { name: 'Czech Koruna', code: 'CZK' },
  { name: 'Danish Krone', code: 'DKK' },
  { name: 'Djibouti Franc', code: 'DJF' },
  { name: 'Dominican Peso', code: 'DOP' },
  { name: 'Egyptian Pound', code: 'EGP' },
  { name: 'El Salvador Colon', code: 'SVC' },
  { name: 'Estonian Kroon', code: 'EEK' },
  { name: 'Ethiopian Birr', code: 'ETB' },
  { name: 'Fiji Dollar', code: 'FJD' },
  { name: 'Gambian Dalasi', code: 'GMD' },
  { name: 'Georgia Lari', code: 'GEL' },
  { name: 'Ghana Cedi', code: 'GHS' },
  { name: 'Gourde', code: 'HTG' },
  { name: 'Guatemala Quetzal', code: 'GTQ' },
  { name: 'Honduras Lempira', code: 'HNL' },
  { name: 'Hong Kong Dollar', code: 'HKD' },
  { name: 'Hungarian Forint', code: 'HUF' },
  { name: 'Iceland Krona', code: 'ISK' },
  { name: 'Indian Rupee', code: 'INR' },
  { name: 'Indonesia Rupiah', code: 'IDR' },
  { name: 'Iranian Rial', code: 'IRR' },
  { name: 'Iraqi Dinar', code: 'IQD' },
  { name: 'Jamaican Dollar', code: 'JMD' },
  { name: 'Japanese Yen', code: 'JPY' },
  { name: 'Jordanian Dinar', code: 'JOD' },
  { name: 'Kazakhstan Tenge', code: 'KZT' },
  { name: 'Kenyan Shilling', code: 'KES' },
  { name: 'Kuwait Dinar', code: 'KWD' },
  { name: 'Lao Kip', code: 'LAK' },
  { name: 'Latvian Lats', code: 'LVL' },
  { name: 'Lebanese Pound', code: 'LBP' },
  { name: 'Lesotho Loti', code: 'LSL' },
  { name: 'Libyan Dinar', code: 'LYD' },
  { name: 'Lithuanian Litas', code: 'LTL' },
  { name: 'Macedonia Denar', code: 'MKD' },
  { name: 'Macoa Pataca', code: 'MOP' },
  { name: 'Malagasy Ariary', code: 'MGA' },
  { name: 'Malawi Kwacha', code: 'MWK' },
  { name: 'Malaysian Ringgit', code: 'MYR' },
  { name: 'Maldives Rufiyaa', code: 'MVR' },
  { name: 'Mauritanian Ouguiya', code: 'MRO' },
  { name: 'Mauritius Rupee', code: 'MUR' },
  { name: 'Mexican Peso', code: 'MXN' },
  { name: 'Moldovan Leu', code: 'MDL' },
  { name: 'Moroccan Dirham', code: 'MAD' },
  { name: 'Myanmar Kyat', code: 'MMK' },
  { name: 'Namibia Dollar', code: 'NAD' },
  { name: 'Nepalese Rupee', code: 'NPR' },
  { name: 'Afghan', code: 'AFN' },
  { name: 'New Israeli Sheqel', code: 'ILS' },
  { name: 'New Leu', code: 'RON' },
  { name: 'New Taiwan Dollar', code: 'TWD' },
  { name: 'New Zealand Dollar', code: 'NZD' },
  { name: 'Nicaraguan Cordoba Oro', code: 'NIO' },
  { name: 'Nigeria Naira', code: 'NGN' },
  { name: 'Norwegian Krone', code: 'NOK' },
  { name: 'Pakistan Rupee', code: 'PKR' },
  { name: 'Panamanian Balboa', code: 'PAB' },
  { name: 'Papua New Guinea Kina', code: 'PGK' },
  { name: 'Paraguay Guarani', code: 'PYG' },
  { name: 'Peruvian Nuevo Sol', code: 'PEN' },
  { name: 'Peso Uruguayo', code: 'UYU' },
  { name: 'Philippine Peso', code: 'PHP' },
  { name: 'Polish Zloty', code: 'PLN' },
  { name: 'Pound Sterling (British Pound)', code: 'GBP' },
  { name: 'Pula', code: 'BWP' },
  { name: 'Qatari Rial', code: 'QAR' },
  { name: 'Rial Omani', code: 'OMR' },
  { name: 'Russian Ruble', code: 'RUB' },
  { name: 'Rwanda Franc', code: 'RWF' },
  { name: 'Sao Tome Dobra', code: 'STD' },
  { name: 'Saudi Riyal', code: 'SAR' },
  { name: 'Serbian Dinar', code: 'RSD' },
  { name: 'Seychelles Rupee', code: 'SCR' },
  { name: 'Singapore Dollar', code: 'SGD' },
  { name: 'Somali Shilling', code: 'SOS' },
  { name: 'South African Rand', code: 'ZAR' },
  { name: 'South Korea Won', code: 'KRW' },
  { name: 'Sri Lanka Rupee', code: 'LKR' },
  { name: 'Sudanese Pound', code: 'SDG' },
  { name: 'Swazi Lilangeni', code: 'SZL' },
  { name: 'Swedish Krona', code: 'SEK' },
  { name: 'Swiss Franc', code: 'CHF' },
  { name: 'Syrian Pound', code: 'SYP' },
  { name: 'Tanzanian Shilling', code: 'TZS' },
  { name: 'Thai Baht', code: 'THB' },
  { name: 'Trinidad and Tobago Dollar', code: 'TTD' },
  { name: 'Tunisian Dinar', code: 'TND' },
  { name: 'Turkish Lira', code: 'TRY' },
  { name: 'UAE Dirham', code: 'AED' },
  { name: 'Uganda Shilling', code: 'UGX' },
  { name: 'Ukranian Hryvnia', code: 'UAH' },
  { name: 'US Dollar', code: 'USD' },
  { name: 'Uzbekistan Sum', code: 'UZS' },
  { name: 'Venezuela Bolivar Fuerte', code: 'VEF' },
  { name: 'Vietnamese Dong', code: 'VND' },
  { name: 'Yemeni Rial', code: 'YER' }
];
